import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import NotFound from "pages/NotFound";
import SidebarLayout from "layouts/sidebar_layout";
import LoginLayout from "layouts/login_layout";
import { AuthProvider } from "context/AuthContext";

import ProtectedRouteSP, {
  ProtectedRouteAdmin,
  ProtectedRouteSPUser,
  ProtectedRouteTenant,
  ProtectedRouteLocAdmin,
  ProtectedRouteLocUser,
} from "components/hoc/ProtectedRouteAdmin";
import { AppPath } from "utils/constants";

const Login = React.lazy(() => import("pages/Login"));
const ForgotPassword = React.lazy(() => import("pages/ForgotPassword"));
const ServiceProvider = React.lazy(() => import("pages/ServiceProvider"));
const TenantManagement = React.lazy(() => import("pages/TenantManagement"));
const UserSP = React.lazy(() => import("pages/UserSP"));
const UserManagement = React.lazy(() => import("pages/UserManagement"));
const Location = React.lazy(() => import("pages/Location"));
const LocationUser = React.lazy(() => import("pages/LocationUser"));
const CameraManagementPage = React.lazy(() => import("pages/CameraManagement"));
const CameraInfoPage = React.lazy(() => import("pages/CameraInfo"));

const ProjectRoutes = () => {
  return (
    <AuthProvider>
      <React.Suspense fallback={<>Loading....</>}>
        <Router>
          <Routes>
            <Route element={<SidebarLayout />}>
              <Route element={<ProtectedRouteSP />}>
                <Route
                  path={AppPath.ServiceProvider}
                  element={<ServiceProvider />}
                />
              </Route>
              <Route element={<ProtectedRouteSPUser />}>
                <Route path={AppPath.UserSP} element={<UserSP />} />
              </Route>
              <Route element={<ProtectedRouteTenant />}>
                <Route
                  path={AppPath.TenantManagement}
                  element={<TenantManagement />}
                />
              </Route>
              <Route element={<ProtectedRouteAdmin />}>
                <Route
                  path={AppPath.UserManagement}
                  element={<UserManagement />}
                />
              </Route>
              <Route element={<ProtectedRouteLocAdmin />}>
                <Route path={AppPath.Location} element={<Location />} />
              </Route>
              <Route element={<ProtectedRouteLocUser />}>
                <Route path={AppPath.LocationUser} element={<LocationUser />} />
              </Route>
              {/* route for camera */}
              <Route
                path={AppPath.CameraManagement}
                element={<CameraManagementPage />}
              />
              <Route
                path={AppPath.CameraInfo}
                element={<CameraInfoPage />}
              />
            </Route>

            <Route element={<LoginLayout />}>
              <Route path={AppPath.Login} element={<Login />} />
            </Route>

            <Route path={AppPath.ForgotPassword} element={<ForgotPassword />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </React.Suspense>
    </AuthProvider>
  );
};
export default ProjectRoutes;
